var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.193 7.31664L19.1864 7.31378L1.38971 0.0746583C1.24002 0.0132146 1.07714 -0.0108829 0.91563 0.00452149C0.75412 0.0199259 0.599022 0.0743517 0.46421 0.16293C0.321778 0.254459 0.204783 0.379279 0.123751 0.52616C0.0427195 0.673041 0.000193807 0.837374 2.27526e-07 1.00437V5.63416C7.93735e-05 5.86246 0.0813656 6.08358 0.229849 6.25942C0.378332 6.43525 0.584709 6.55477 0.81341 6.59739L10.5197 8.35752C10.5579 8.36461 10.5923 8.38453 10.6171 8.41385C10.6418 8.44317 10.6554 8.48005 10.6554 8.51812C10.6554 8.55619 10.6418 8.59307 10.6171 8.62239C10.5923 8.65171 10.5579 8.67164 10.5197 8.67873L0.813826 10.4389C0.58519 10.4814 0.378824 10.6007 0.230275 10.7764C0.0817253 10.9521 0.000291703 11.173 2.27526e-07 11.4013V16.0319C-0.00011044 16.1913 0.0401514 16.3483 0.117173 16.4888C0.194194 16.6292 0.305565 16.7487 0.441291 16.8365C0.604556 16.9429 0.79616 16.9998 0.992176 17C1.12845 16.9999 1.26332 16.9731 1.38888 16.9211L19.1851 9.72328L19.193 9.7196C19.4326 9.61864 19.6367 9.45102 19.7801 9.23747C19.9236 9.02393 20 8.77383 20 8.51812C20 8.26241 19.9236 8.01232 19.7801 7.79877C19.6367 7.58523 19.4326 7.4176 19.193 7.31664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.917ddd6b544833f68ea6f1249ae22703.svg";
export { ForwardRef as ReactComponent };